var _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _circle4, _path5, _circle5, _path6, _circle6, _path7, _circle7, _path8, _circle8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle82A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 80",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M37.5 8a2.5 2.5 0 0 1 2.5 2.5v59a2.5 2.5 0 0 1-2.5 2.5h-15a2.5 2.5 0 0 1-2.5-2.5v-59A2.5 2.5 0 0 1 22.5 8h15Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 47.992,
  r: 6,
  fill: "#464D57",
  transform: "rotate(-90 11 47.992)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6.757 52.234a6 6 0 0 1 0-8.485"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 63.992,
  r: 6,
  fill: "#464D57",
  transform: "rotate(-90 11 63.992)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6.757 68.234a6 6 0 0 1 0-8.485"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 16.008,
  r: 6,
  fill: "#464D57",
  transform: "rotate(90 49 16.008)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M53.243 11.766a6 6 0 0 1 0 8.485"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 31.992,
  r: 6,
  fill: "#464D57",
  transform: "rotate(-90 11 31.992)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6.757 36.234a6 6 0 0 1 0-8.485"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 32.008,
  r: 6,
  fill: "#464D57",
  transform: "rotate(90 49 32.008)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M53.243 27.766a6 6 0 0 1 0 8.485"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 15.992,
  r: 6,
  fill: "#464D57",
  transform: "rotate(-90 11 15.992)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6.757 20.234a6 6 0 0 1 0-8.485"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 48.008,
  r: 6,
  fill: "#464D57",
  transform: "rotate(90 49 48.008)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M53.243 43.766a6 6 0 0 1 0 8.485"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 64.008,
  r: 6,
  fill: "#464D57",
  transform: "rotate(90 49 64.008)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M53.243 59.766a6 6 0 0 1 0 8.485"
})));
SvgRectangle82A.viewBox = '0 0 60 80';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle82A);
export default ForwardRef;